import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53f9d863"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card d-flex flex-row flex-wrap p-4 gap-3",
  style: {"font-size":"14px"},
  id: "bodyComponent"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center col-12\" style=\"gap:20px;\" data-v-53f9d863><div class=\"d-flex flex-row align-items-center gap-4\" data-v-53f9d863><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-53f9d863><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-53f9d863></rect><path opacity=\"0.5\" d=\"M21.2326 33.4375C20.4559 33.4375 19.8285 32.7393 19.8285 31.875C19.8285 31.0107 20.4559 30.3125 21.2326 30.3125C22.0092 30.3125 22.6366 31.0107 22.6366 31.875C22.6366 32.7393 22.0092 33.4375 21.2326 33.4375Z\" fill=\"#203972\" data-v-53f9d863></path><path d=\"M26.1468 10H16.3183C15.1556 10 14.2122 11.0498 14.2122 12.3438V32.6562C14.2122 33.9502 15.1556 35 16.3183 35H26.1468C27.3096 35 28.2529 33.9502 28.2529 32.6562V12.3438C28.2529 11.0498 27.3096 10 26.1468 10ZM21.2326 33.4375C20.456 33.4375 19.8285 32.7393 19.8285 31.875C19.8285 31.0107 20.456 30.3125 21.2326 30.3125C22.0092 30.3125 22.6367 31.0107 22.6367 31.875C22.6367 32.7393 22.0092 33.4375 21.2326 33.4375ZM26.1468 28.1641C26.1468 28.4863 25.9099 28.75 25.6203 28.75H16.8449C16.5553 28.75 16.3183 28.4863 16.3183 28.1641V12.9297C16.3183 12.6074 16.5553 12.3438 16.8449 12.3438H25.6203C25.9099 12.3438 26.1468 12.6074 26.1468 12.9297V28.1641Z\" fill=\"#203972\" data-v-53f9d863></path></svg><p class=\"subtitulo cor_texto_1 m-0\" data-v-53f9d863>Config. do App</p></div></div>", 1)
const _hoisted_3 = { class: "justify-content-between rounded-2 flex-column card-item" }
const _hoisted_4 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Busca pela placa", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "m-0",
    style: {"color":"#b5b5c3"}
  }, "Habilita no app a funcionalidade de buscar o veículo pela placa.")
], -1))
const _hoisted_7 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_8 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Pode alterar valor", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Permite que o usuário edite o preço na tela de cardápio.")
], -1))
const _hoisted_11 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_12 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Usa checklist", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Permite que a loja use um checklist de inspeção veicular.")
], -1))
const _hoisted_15 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_16 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Formulário de recepção", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Começa o fluxo de atendimento com o formulário primeiro.")
], -1))
const _hoisted_19 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_20 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Utiliza valor M.O", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Discrimina o valor de cada serviço separando Peça e M.O.")
], -1))
const _hoisted_23 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_24 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Venda de óleo fracionado", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Adiciona um campo de edição na quantidade de óleo ao cardápio.")
], -1))
const _hoisted_27 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_28 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Vende estoque negativo", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Não bloqueia a venda quando o produto está sem estoque.")
], -1))
const _hoisted_31 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_32 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Pode dar desconto", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Habilita a funcionalidade de aplicar desconto ao pacote.")
], -1))
const _hoisted_35 = { class: "justify-content-between rounded-1 flex-column card-item" }
const _hoisted_36 = {
  class: "cardSwitch d-flex justify-content-between mb-2",
  style: {"gap":"20px","height":"70px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title texto" }, "Assinatura do cliente", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#b5b5c3"} }, "Adiciona um campo na tela de atendimento para o cliente assinar.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.buscaPlaca,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.grupoProp.buscaPlaca) = $event)),
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0,
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.alterarValor,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grupoProp.alterarValor) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.usaChecklist,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.grupoProp.usaChecklist) = $event)),
          class: "ml-2",
          "active-value": 1,
          "inactive-value": 0,
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_14
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.formularioDeRecepcao,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.grupoProp.formularioDeRecepcao) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_18
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.utilizaMO,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.grupoProp.utilizaMO) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_22
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.oleoFracionado,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.grupoProp.oleoFracionado) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_26
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.vendaEstoqueNegativo,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.grupoProp.vendaEstoqueNegativo) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_30
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.podeDesconto,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.grupoProp.podeDesconto) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_34
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createVNode(_component_el_switch, {
          modelValue: _ctx.grupoProp.assinaturaDoCliente,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.grupoProp.assinaturaDoCliente) = $event)),
          class: "ml-2",
          "active-value": "S",
          "inactive-value": "N",
          style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_38
    ])
  ]))
}